import { captureException, withScope } from "@sentry/browser";
import React from "react";

class ErrorBoundary extends React.Component {
  state = {
    error: null,
    errorInfo: null,
  };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    withScope((scope) => {
      scope.setExtra("componentStack", errorInfo.componentStack);
      scope.setExtra("timestamp", new Date().toISOString());
      scope.setLevel("error");
      captureException(error);
    });

    this.setState({ errorInfo });
    this.props.onError?.(error, errorInfo);
  }

  componentDidUpdate(prevProps) {
    if (this.state.error && this.props.resetKeys && prevProps.resetKeys !== this.props.resetKeys) {
      this.resetErrorBoundary();
    }
  }

  resetErrorBoundary = () => {
    this.setState({
      error: null,
      errorInfo: null,
    });
  };

  render() {
    if (this.state.error) {
      return (
        <div className="tw-py-32 tw-pl-20 tw-relative tw-w-screen tw-h-screen">
          <div className="tw-relative tw-z-10" role="alert" aria-live="polite">
            <p className="tw-text-gray-400 tw-text-4xl tw-leading-tight tw-font-medium">Oops</p>
            <p className="tw-text-3xl tw-leading-tight tw-font-semibold tw-text-black">Something went wrong!</p>
            {process.env.NODE_ENV === "development" && this.state.error && <pre className="tw-text-red-500 tw-mt-2">{this.state.error.message}</pre>}
            <button
              type="button"
              className="tw-bg-primary-purple-500 tw-text-white tw-font-semibold tw-border-blue-500 tw-rounded tw-text-base tw-leading-5 tw-text-center tw-py-4 tw-px-3 tw-mt-3"
              onClick={this.resetErrorBoundary}
            >
              Try Again
            </button>
          </div>
          <div className="tw-absolute tw-right-0 tw-bottom-0 tw-w-[1120px]">
            <img width={1120} height={672} src="https://res.cloudinary.com/drzta9shk/image/upload/v1712819193/intel/misc/sww_insideproduct_z3dopw.png" alt="Error illustration" />
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
